export default __webpack_public_path__ + "static/media/loading.53e741d3.gif";